import React from 'react';
import { Link } from 'react-router-dom';
import { mockArticles } from '../services/dataService';
import { getArticleImage } from '../utils/imageUtils';

/**
 * Article List Page Component
 */
const ArticleList = () => {
  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        📝 Articles
      </h1>
      <div className="grid">
        {mockArticles.map(article => (
          <div key={article.id} className="card">
            <img 
              src={getArticleImage(article.id, article.title)} 
              alt={article.title}
              style={{ 
                width: '100%', 
                height: '200px', 
                objectFit: 'cover', 
                borderRadius: '8px', 
                marginBottom: '15px' 
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {article.title}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Category:</strong> {article.category}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Author:</strong> {article.author}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Published:</strong> {article.publishedDate}
            </p>
            <p style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>
              {article.content.substring(0, 200)}...
            </p>
            <Link to={`/articles/${article.id}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              Read Article
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArticleList;
